import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutCeoPage from "../pages/about/ceo/page";
import AboutOverviewPage from "../pages/about/overview/page";
import AboutHistoryPage from "../pages/about/history/page";
import AboutCertificationsPage from "../pages/about/certifications/page";
import AboutLocationPage from "../pages/about/location/page";
import BusinessPage from "../pages/business/page";
import ProductsPage from "../pages/products/page";
import ProductDetailPage from "../pages/products/detail/page";
import TechnicalPage from "../pages/technical/page";
import SupportPage from "../pages/support/page";
import ContactPage from "../pages/contact/page";
import QuotationPage from "../pages/quotation/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminDashboardPage from "../pages/admin/dashboard/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about/ceo", element: <AboutCeoPage /> },
  { path: "/about/overview", element: <AboutOverviewPage /> },
  { path: "/about/history", element: <AboutHistoryPage /> },
  { path: "/about/certifications", element: <AboutCertificationsPage /> },
  { path: "/about/location", element: <AboutLocationPage /> },
  { path: "/business", element: <BusinessPage /> },
  { path: "/products", element: <ProductsPage /> },
  { path: "/products/:id", element: <ProductDetailPage /> },
  { path: "/technical", element: <TechnicalPage /> },
  { path: "/support", element: <SupportPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/quotation", element: <QuotationPage /> },
  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "/admin/dashboard", element: <AdminDashboardPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;